'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _sellerCatalogs = require('./remote/sellerCatalogs');

var SellerCatalogs = {
    fetchSellerEndedCatalogsById: function fetchSellerEndedCatalogsById(params) {
        return _sellerCatalogs.SellerCatalogsRemote.fetchSellerEndedCatalogsById(params);
    },
    fetchSellerUpcomingCatalogsById: function fetchSellerUpcomingCatalogsById(params) {
        return _sellerCatalogs.SellerCatalogsRemote.fetchSellerUpcomingCatalogsById(params);
    }
};

exports.default = SellerCatalogs;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/sellerCatalogs.js
// module id = kIRm
// module chunks = 46